import { render } from "./index.vue?vue&type=template&id=885fa518&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=885fa518&lang=scss&scope=true"

import exportComponent from "/Users/haoxunming/Desktop/flowbox公司项目/flowbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__